import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateReport, Report, ReportListResponse, ReportQueryParams, UpdateReport } from '@frontend/report/types';

export class ReportClient extends APIClient {
    public static readonly endpoint = '/report-api/v1';

    public static async fetchReports(queryParams?: ApiQueryParams<ReportQueryParams>): Promise<ReportListResponse> {
        return await this.apiPaginated<ReportListResponse, ReportQueryParams>(`${this.endpoint}/reports`, queryParams);
    }

    public static async resolveReports(ids: string[], field: keyof Report = 'id'): Promise<ReportListResponse> {
        const response = await this.post(`${this.endpoint}/reports-resolve`, { field, ids: ids });
        return await this.handleResponse<ReportListResponse>(response);
    }

    public static async deleteReports(reportIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/reports-delete`, { ids: reportIds });
        return await this.handleVoidResponse(response);
    }

    public static async postReport(accountId: string, report: CreateReport): Promise<Report> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/reports`, report);
        return await this.handleResponse<Report>(response);
    }

    public static async fetchReport(accountId: string, reportId: string): Promise<Report> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/reports/${reportId}`);
        return await this.handleResponse<Report>(response);
    }

    public static async patchReport(accountId: string, reportId: string, report: UpdateReport): Promise<Report> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/reports/${reportId}`, report);
        return await this.handleResponse<Report>(response);
    }

    public static async deleteReport(accountId: string, reportId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/reports/${reportId}`);
        return await this.handleVoidResponse(response);
    }
}
